import { FC, useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { Select } from '@forto-dev/phoenix-ui-core'

import { usersQueryOptions } from '@/features/users'
import { useLocalisation } from '@/utils/localisation'

import { useSubscriptionCreate } from '../api/useSubscriptionCreate'

export type AddSubscriberProps = {
  id: string
  subscribedUserIds: string[]
}

// Loads the company users, so only render it for users who may edit subscribers
export const AddSubscriber: FC<AddSubscriberProps> = ({ id, subscribedUserIds }) => {
  const { translate } = useLocalisation()
  const users = useQuery(usersQueryOptions())
  const createMutation = useSubscriptionCreate()
  const unsubscribed = useMemo(
    () => (users.data ?? []).filter((user) => !subscribedUserIds.includes(user.id)),
    [users.data, subscribedUserIds]
  )

  return (
    <Select
      onChange={async (newSubscriptionUserId) => {
        await createMutation.mutateAsync({
          entityId: id,
          userId: newSubscriptionUserId,
        })
      }}
      items={unsubscribed.map((user) => ({
        value: user.id,
        label: `${user.firstName} ${user.lastName} (${user.email})`,
      }))}
      placeholder={translate('subscriptions.dialog.placeholder')}
      searchable
    />
  )
}
